import { Card, ForgotPasswordForm } from "../components";
import { usePageTitle } from "../hooks";

/**
 * ForgotPasswordPage - Password reset request page.
 */
export function ForgotPasswordPage() {
  usePageTitle("Reset Password");

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-4 py-8">
      <Card variant="elevated" className="w-full max-w-md p-8">
        <h1 className="font-display font-bold text-display-sm text-magic-600 text-center mb-2">
          Forgot Password?
        </h1>
        <p className="font-body text-body-md text-neutral-600 text-center mb-8">
          No worries, we'll help you reset it!
        </p>

        <ForgotPasswordForm />
      </Card>
    </div>
  );
}

export default ForgotPasswordPage;
